import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { StepTermoFinalizacaoProps } from "../../../../../interfaces/props/Financeiro/Reembolso/StepTermoFinalizacaoProps";
import { formatStringToReaisNumberFormat } from "../../../../../utils/MoneyFormat";
import { sxDarkGreyBody } from "../../../../MeuPlano/PermissoesVisualizacao/sxProps";
import AttachmentsCard from "../AttachmentsCard";
import TotalValueCard from "../TotalValueCard";
import AccountDataCard from "./AccountDataCard";
import BenefDataCard from "./BenefDataCard";
import ProcedsDataCard from "./ProcedsDataCard";
import './styles.css';
import DefaultButton from "../../../../../components/Accessibility/DefaultButton";
import { useEffect, useRef } from "react";

const StepTermoFinalizacao: React.FC<StepTermoFinalizacaoProps> = ({
  handleBack, handleProceed, handleEditInfos, accountData, attachments, benefData, procedData, totalValue, benef, cel, email
}) => {

  const pageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    pageRef?.current?.focus();
  }, []);

  return (
    <div className="feature-container" tabIndex={-1} ref={pageRef}>
      <Typography sx={sxDarkGreyBody}>Revise os dados do seu reembolso:</Typography>
      <BenefDataCard benef={benef} cel={cel} email={email} />
      <AccountDataCard account={accountData} />
      <ProcedsDataCard lstProceds={procedData} />
      <AttachmentsCard anexos={attachments} />
      <TotalValueCard totalValue={'R$ ' + formatStringToReaisNumberFormat(totalValue)} />
      <div className="account-modal-buttons">
        <div className="account-modal-button">
          <DefaultButton
            aria-label={`Editar informações do reembolso dos procedimentos de valor total ${totalValue}`}
            variant="outlined"
            onClick={handleEditInfos}
            disabled={false}
            text="Editar informações" />
        </div>
        <div className="account-modal-button">
          <DefaultButton
            aria-label={`Enviar pedido de reembolso dos procedimentos de valor total ${totalValue}`}
            variant="contained"
            disabled={false}
            onClick={handleProceed}
            text="Enviar"/>
        </div>
      </div>
      <button className="back-button" onClick={() => handleBack()}>
        <FontAwesomeIcon icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
      </button>
    </div>
  )
}

export default StepTermoFinalizacao;